import axios from "axios";
import axiosRetry from "axios-retry";

import { getEnvConfig } from "@/config/environments";
import { getJwt } from "@/services/authService";

export function apiClient() {
  const client = axios.create({
    baseURL: getEnvConfig().APIDomain,
    headers: {
      "Content-Type": "application/json",
      "Canopy-App": "os",
    },
  });

  client.interceptors.request.use(async (config) => {
    const jwt = await getJwt();
    if (jwt && config.headers) config.headers["Authorization"] = `Bearer ${jwt}`;
    return config;
  });

  // Configure the retry mechanism, but make it specific to every request
  axiosRetry(client, { retries: 0 });

  return client;
}

export function newAPIClient(jwt: string) {
  return axios.create({
    baseURL: getEnvConfig().APIDomain,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${jwt}`,
    },
  });
}
